<template>
  <div class="tinymce-editor-container">
    <div :id="editorId"></div>
  </div>
</template>

<script>
import emitter from 'element-ui/src/mixins/emitter'
import { isEn } from '@/i18n'
import tinymce from 'tinymce'
import 'tinymce/plugins/image'
import 'tinymce/plugins/imagetools'
import 'tinymce/plugins/link'
import 'tinymce/plugins/media'
import 'tinymce/plugins/table'
import 'tinymce/plugins/lists'
import 'tinymce/plugins/advlist'
import _ from 'lodash'
import {
  buildNewTemplateCandidateContainer,
  buildNewTemplateCandidateItem,
  normalizeInterviewEmailThemeColor,
  replaceNewTemplateCandidateSection,
  replaceNewTemplateDashboardButton
} from '@/utils/interviewEmail'

export default {
  mixins: [emitter],
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: String,
      required: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    applicationList: {
      required: false
    },
    emailLanguage: {
      type: String,
      default: 'zh-cn'
    },
    showGenerateAISummaryButton: {
      type: Boolean,
      default: false
    },
    showGenerateAIMatchButton: {
      type: Boolean,
      default: false
    },
    aiTemplateField: {
      type: String,
      default: ''
    },
    themeColor: {
      type: String,
      default: '#0096cc'
    }
  },
  data () {
    const editorId = `instance_${new Date().valueOf()}_${parseInt(Math.random() * 1000 + 1)}`
    return {
      isEn,
      editorId,
      editor: null,
      summaryTimers: {},
      candidateTaskList: []
    }
  },
  computed: {
    emailThemeColor () {
      return normalizeInterviewEmailThemeColor(this.themeColor)
    },
    contentStyle () {
      const style = `
        body { width: 600px; margin: 0 auto; }
        @-webkit-keyframes rect-loading-animation {
          0%, 40%, 100% {
            -webkit-transform: scaleY(0.4);
                    transform: scaleY(0.4);
          }
          20% {
            -webkit-transform: scaleY(1);
                    transform: scaleY(1);
          }
        }
        @keyframes rect-loading-animation {
          0%, 40%, 100% {
            -webkit-transform: scaleY(0.4);
                    transform: scaleY(0.4);
          }
          20% {
            -webkit-transform: scaleY(1);
                    transform: scaleY(1);
          }
        }
        .custom-tag {
          display: inline-block;
          max-width: 600px;
          &:hover {
            cursor: pointer;
            outline: 3px solid #b4d7ff;
          }
        }
        #custom-tag-candidate_ai_summary {
          display: inline-block;
          max-width: 600px;
          &:hover {
            outline: unset;
          }
          .view-dashboard-btn-content {
            text-align: right;
            height: 36px;
            width: 600px;
            .view-dashboard-btn {
              border: 1px solid grey !important;
              color: grey !important;
              padding: 10px 20px;
              cursor: pointer;
              background: #fff;
              font-size: 14px;
              display: block;
              line-height: 1;
              white-space: nowrap;
              border-radius: 2px;
              float: right;
              cursor: not-allowed !important;
              outline: unset !important;
              a {
                text-decoration: none;
                color: grey !important;
                cursor: not-allowed !important;
              }
            }
          }
        }
        .candidate-summary-item {
          font-size: 14px;
          line-height: 20px;
          margin-bottom: 20px;
          .candidate-name {
            display: block;
            height: 46px;
            width: 600px;
            margin-bottom: 10px;
            .name {
              font-size: 16px;
              font-weight: 700;
              float: left;
              line-height: 36px;
              height: 36px;
              color: grey !important;
              cursor: not-allowed !important;
              a {
                text-decoration: none;
                color: grey !important;
                cursor: not-allowed !important;
              }
            }
            .rate-btn {
              border: 1px solid grey !important;
              color: grey !important;
              padding: 10px 20px;
              cursor: not-allowed !important;
              outline: unset !important;
              background: #fff;
              font-size: 14px;
              display: block;
              line-height: 1;
              white-space: nowrap;
              margin: 0;
              border-radius: 2px;
              float: right;
              a {
                text-decoration: none;
                color: grey !important;
                cursor: not-allowed !important;
              }
            }
          }
          .candidate-summary-content {
            border: 1px solid #ccc;
            max-height: 200px;
            overflow-y: auto;
            margin-bottom: 10px;
            padding: 10px;
            min-height: 120px;
            position: relative;
          }
          .candidate-ai-match-content {
            border: 1px solid #ccc;
            max-height: 200px;
            overflow-y: auto;
            padding: 10px;
            min-height: 120px;
            position: relative;
          }
          .ai-summary-loading {
            position: absolute;
            z-index: 10000;
            display: flex;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: #fff;
            opacity: .85;
            .loading-spinner {
              margin: auto;
              .spinner {
                width: 45px;
                height: 40px;
                text-align: center;
                font-size: 10px;
                display: -webkit-box;
                display: -ms-flexbox;
                display: flex;
                -webkit-box-pack: justify;
                -ms-flex-pack: justify;
                justify-content: space-between;
                div {
                  display: inline-block;
                  height: 100%;
                  width: 6px;
                  background-color: #333;
                  -webkit-animation: rect-loading-animation 1.2s infinite ease-in-out;
                  animation: rect-loading-animation 1.2s infinite ease-in-out;
                }
                .rect2 {
                  -webkit-animation-delay: -1.1s;
                  animation-delay: -1.1s;
                }
                .rect3 {
                  -webkit-animation-delay: -1.0s;
                  animation-delay: -1.0s;
                }
                .rect4 {
                  -webkit-animation-delay: -0.9s;
                  animation-delay: -0.9s;
                }
                .rect5 {
                  -webkit-animation-delay: -0.8;
                  animation-delay: -0.8s;
                }
              }
            }
          }
          .generate-ai-summary-btn {
            position: absolute;
            bottom: 14px;
            right: 8px;
            border: 1px solid #0096cc;
            color: #0096cc;
            padding: 10px 20px;
            cursor: pointer;
            background: #fff;
            font-size: 14px;
            display: inline-block;
            line-height: 1;
            white-space: nowrap;
            margin: 0;
            border-radius: 2px;
            .generate-icon {
              margin-left: 6px;
            }
          }
          .generate-ai-match-btn {
            position: absolute;
            bottom: 14px;
            right: 8px;
            border: 1px solid #0096cc;
            color: #0096cc;
            padding: 10px 20px;
            cursor: pointer;
            background: #fff;
            font-size: 14px;
            display: inline-block;
            line-height: 1;
            white-space: nowrap;
            margin: 0;
            border-radius: 2px;
            .generate-icon {
              margin-left: 6px;
            }
          }
        }
        table#custom-tag-candidate_ai_summary {
          display: table;
          width: 568px;
          max-width: 568px;
        }
        table#custom-tag-candidate_ai_summary table.candidate-summary-item {
          display: table;
          width: 520px;
          margin-bottom: 0;
        }
      `
      return style
    }
  },
  created () {
  },
  async mounted () {
    await this.createEditor()
    if (!this.editor) {
      return
    }
    if (this.applicationList) {
      const vm = this
      const aiCustomTag = buildNewTemplateCandidateContainer(this.emailLanguage)
      const hasExistContent = this.editor.getBody().innerHTML
      const candidateSectionContent = replaceNewTemplateCandidateSection(
        hasExistContent,
        this.aiTemplateField,
        aiCustomTag,
        this.emailLanguage,
        this.emailThemeColor
      )
      if (candidateSectionContent !== hasExistContent) {
        this.editor.setContent(candidateSectionContent)
      }
      const applicationList = _.sortBy(this.applicationList, application => Number(application.candidate.id))
      _.forEach(applicationList, application => {
        const aiSummaryInfo = application.candidate.ai_summary_info
        const aiMatchInfo = application.candidate.ai_match_info
        const aiMatchScore = aiMatchInfo ? aiMatchInfo.resume_ai_match_score : ''
        const aiSummaryContent = _.get(aiSummaryInfo, this.emailLanguage === 'en' ? 'ai_summary_en' : 'ai_summary_cn')
        const aiMatchSummaryContent = _.get(aiMatchInfo, this.emailLanguage === 'en' ? 'resume_ai_match_summary_en' : 'resume_ai_match_summary_cn')
        const content = {
          candidate_id: application.candidate.id,
          job_id: application.job.id,
          candidate_name: application.candidate.name,
          summary: aiSummaryContent,
          ai_match_summary: aiMatchSummaryContent,
          ai_match_score: aiMatchScore
        }
        this.initNewTemplateCandidateAISummary(content)
      })
      _.forEach(applicationList, application => {
        const el = this.editor.getBody().querySelector(`#generate-ai-summary-btn_${application.candidate.id}`)
        if (el) {
          el.addEventListener('click', () => {
            vm.generateAISummaryOrMatch(application)
          })
          if (!el.querySelector('.generate-icon')) {
            const container = document.createElement('span')
            container.className = 'generate-icon'
            container.innerHTML = '<i class="iconfont icona-ResumeSummary"></i>'
            el.appendChild(container)
          }
        }
        const elMatch = this.editor.getBody().querySelector(`#generate-ai-match-btn_${application.candidate.id}`)
        if (elMatch) {
          elMatch.addEventListener('click', () => {
            vm.generateAISummaryOrMatch(application, true)
          })
          if (!elMatch.querySelector('.generate-icon')) {
            const container = document.createElement('span')
            container.className = 'generate-icon'
            container.innerHTML = '<i class="iconfont icona-ResumeSummary"></i>'
            elMatch.appendChild(container)
          }
        }
      })
      this.editor.focus()
    }
  },
  beforeDestroy () {
    if (this.editor) {
      tinymce.remove(this.editor)
    }
    this.editor = null
  },
  methods: {
    normalizeNewTemplateContent (content) {
      return replaceNewTemplateDashboardButton(content, this.emailLanguage, this.emailThemeColor)
    },
    setup (editor) {
      editor.on('keydown', (e) => {
        if (e.keyCode === 13) {
          // 回车键被按下
          const selectedNode = editor.selection.getNode()
          // 如果选中节点的标签名是 'CUSTOM-TAG' 或者 AI Summary
          if (this.checkSelectNodeNeedControl(selectedNode)) {
            e.preventDefault() // 阻止默认的回车事件
            if (editor.dom.isEmpty(selectedNode)) {
              // 换行插入 'br'
              editor.execCommand('InsertLineBreak')
            } else {
              editor.execCommand('mceInsertContent', false, '<div></div>')
            }
          }
        }
      })
    },
    /**
     * 检查选中节点是否需要控制回车事件，因为一些节点回车后内容显示不对例如'CUSTOM-TAG'
     * @param {Node} selectedNode
     */
    checkSelectNodeNeedControl (selectedNode) {
      if (selectedNode.tagName === 'CUSTOM-TAG' || _.includes(selectedNode.id, 'candidate-summary-content_') || _.includes(selectedNode.id, 'candidate_summary_') || _.includes(selectedNode.id, 'candidate-ai-match-content') || _.includes(selectedNode.id, 'candidate_ai_match_')) {
        return true
      }
      if (selectedNode.parentNode) {
        return this.checkSelectNodeNeedControl(selectedNode.parentNode)
      }
    },
    async createEditor () {
      if (!this.editor) {
        const setting = {
          base_url: `${window.location.origin}/vue-static/tinymce`,
          suffix: '.min',
          target: this.$el.firstElementChild,
          min_height: 500,
          content_style: this.contentStyle,
          plugins: ['image', 'imagetools', 'link', 'media', 'table', 'lists', 'advlist'],
          toolbar: [
            'bold italic underline link formatselect fontselect fontsizeselect'
          ],
          visual: false,
          extended_valid_elements: 'email-header, email-footer, custom-tag',
          custom_elements: 'email-header,email-footer,custom-tag',
          setup: this.setup,
          branding: false,
          resize: true,
          toolbar_mode: 'wrap',
          convert_urls: false,
          relative_urls: false,
          content_css: [
            // 这里使用后端的 iconfont 是因为前端项目的 iconfont css 引用到 tinymce 编辑器中很麻烦
            '/static/iconfont/iconfont.css'
          ],
          language: isEn() ? 'en' : 'zh_CN',
          menubar: false,
          images_upload_handler: (blobInfo, success, failure, progress) => {
            const reader = new FileReader()
            reader.readAsDataURL(blobInfo.blob())
            reader.onloadend = () => {
              success(reader.result)
            }
          }
        }
        const editors = await tinymce.init(setting)
        const editor = editors[0]
        this.editor = editor
        editor.on('change input undo redo', () => {
          const content = editor.getContent()
          this.$emit('change', content)
          this.dispatch('ElFormItem', 'el.form.change', [content])
        })
      }
      const content = this.normalizeNewTemplateContent(this.value || '')
      this.editor.setContent(content)
      if (content !== this.value) {
        this.$emit('change', content)
      }
      this.editor.settings.link_title = false
      this.editor.settings.default_link_target = '_blank'
      if (this.disabled) {
        this.editor.setMode('readonly')
      }
    },
    checkTaskList () {
      if (!this.candidateTaskList.length) {
        this.$emit('enableOperateBtn')
      }
    },
    clearTaskByCandidateId (candidateId) {
      if (this.summaryTimers[candidateId]) {
        clearInterval(this.summaryTimers[candidateId].toggleCursorBlinkInterval)
        clearInterval(this.summaryTimers[candidateId].typingInterval)
        this.summaryTimers[candidateId].toggleCursorBlinkInterval = null
        this.summaryTimers[candidateId].typingInterval = null
        _.pull(this.candidateTaskList, candidateId)
        this.checkTaskList()
      }
    },
    generateAISummaryOrMatch (application, isMatch = false) {
      const candidateId = application.candidate.id
      const jobId = application.job.id
      const editor = this.editor
      const aiSummaryLoadingEl = editor.getBody().querySelector(`#ai-summary-loading_${candidateId}`)
      aiSummaryLoadingEl.style.display = 'block'
      const emitEvent = isMatch ? 'generateAIMatch' : 'generateAISummary'
      const generateBtnElId = isMatch ? '#generate-ai-match-btn' : '#generate-ai-summary-btn'
      const generateBtnEl = editor.getBody().querySelector(`${generateBtnElId}_${application.candidate.id}`)
      this.clearTaskByCandidateId(candidateId)
      this.candidateTaskList.push(candidateId)
      this.$emit(emitEvent, candidateId, jobId, this.emailLanguage, (content) => {
        const vm = this
        aiSummaryLoadingEl.style.display = 'none'
        generateBtnEl.style.display = 'none'
        let summary
        if (isMatch) {
          summary = vm.emailLanguage === 'en' ? content.resume_ai_match_summary_en : content.resume_ai_match_summary_cn
        } else {
          summary = content.summary
        }
        if (isMatch) {
          const aiMatchScore = content.resume_ai_match_score
          vm.initNewTemplateFitScore(candidateId, aiMatchScore)
          _.pull(this.candidateTaskList, candidateId)
          this.checkTaskList()
        } else {
          // 暂时不展示 AI match summary
          vm.insertBlocks(candidateId, summary, true, isMatch)
        }
      })
    },
    initNewTemplateCandidateAISummary (content) {
      const candidateId = content.candidate_id
      const summary = content.summary
      const aiMatchScore = content.ai_match_score
      const selectedNode = this.editor.getBody().querySelector('.candidate-ai-summary')
      if (!selectedNode) {
        return
      }
      selectedNode.style.cursor = 'auto'

      if (!selectedNode.querySelector('.candidate-summary-item')) {
        selectedNode.innerHTML = ''
      }

      const existingItem = selectedNode.querySelector(`#candidate-summary-item_${candidateId}`)
      if (existingItem) {
        existingItem.remove()
      }

      const container = document.createElement('div')
      container.innerHTML = buildNewTemplateCandidateItem({
        candidateId,
        candidateName: content.candidate_name,
        rateLink: `\${rate_link_${candidateId}}`,
        languageCode: this.emailLanguage,
        themeColor: this.emailThemeColor,
        showSummary: false,
        summary,
        allowGenerateSummary: false,
        showFitScore: false,
        fitScoreImageUrl: '',
        fitScoreValue: aiMatchScore,
        allowGenerateFitScore: false,
        showLoading: false
      })
      selectedNode.appendChild(container.firstElementChild)
      this.editor.setContent(this.editor.getBody().innerHTML)

      if (summary && this.showGenerateAISummaryButton) {
        const candidateSummaryEl = this.editor.getBody().querySelector(`#candidate_summary_${candidateId}`)
        if (candidateSummaryEl) {
          candidateSummaryEl.innerText = summary
        }
      }
    },
    initNewTemplateFitScore (candidateId, fitScore) {
      const fitScoreEl = this.editor.getBody().querySelector(`#ai-match-fit-score_${candidateId}`)
      if (!fitScoreEl) {
        return
      }
      const scoreEl = document.createElement('span')
      scoreEl.style.cssText = 'display: inline-block; width: 28px; height: 28px; border: 1px solid #dcdfe6; font-size: 12px; line-height: 28px; text-align: center; mso-line-height-rule: exactly;'
      scoreEl.textContent = fitScore
      fitScoreEl.innerHTML = ''
      fitScoreEl.appendChild(scoreEl)
    },
    /**
     * 在邮件内容中插入额外内容
     * @param {string | number} candidateId 求职者ID
     * @param {string} summary 内容
     * @param {boolean} isTypingEnabled 是否开启打字机样式, 默认 true
     * @param {boolean} isMatch 是否是 AI match ,默认 false
     */
    insertBlocks (candidateId, summary, isTypingEnabled = true, isMatch = false) {
      const editor = this.editor
      let displayedContent = ''

      const cursorElId = isMatch ? '#cursor_ai_match' : '#cursor'
      const summaryContentElId = isMatch ? '#candidate-ai-match-content' : '#candidate-summary-content'
      const summaryElId = isMatch ? '#candidate_ai_match' : '#candidate_summary'

      const cursorEl = editor.getBody().querySelector(`${cursorElId}_${candidateId}`)
      if (!this.summaryTimers[candidateId]) {
        this.summaryTimers[candidateId] = {
          toggleCursorBlinkInterval: null,
          typingInterval: null
        }
      }
      this.summaryTimers[candidateId].toggleCursorBlinkInterval = setInterval(() => {
        if (cursorEl) {
          cursorEl.style.display = cursorEl.style.display === 'none' ? '' : 'none'
        }
      }, 200)
      const aiSummaryContentEl = editor.getBody().querySelector(`${summaryContentElId}_${candidateId}`)
      this.summaryTimers[candidateId].typingInterval = setInterval(() => {
        editor.focus()
        const candidateSummaryEl = editor.getBody().querySelector(`${summaryElId}_${candidateId}`)
        if (displayedContent.length < summary.length) {
          if (isTypingEnabled) {
            displayedContent += summary[displayedContent.length]
            this.$nextTick(() => {
              if (aiSummaryContentEl.scrollHeight > aiSummaryContentEl.clientHeight) {
                aiSummaryContentEl.scrollTop = aiSummaryContentEl.scrollHeight
              }
            })
          } else {
            displayedContent = summary
          }
          // 更新编辑器的内容
          candidateSummaryEl.innerText = displayedContent
        } else {
          // 隐藏光标
          const cursorEl = editor.getBody().querySelector(`${cursorElId}_${candidateId}`)
          if (cursorEl) {
            cursorEl.style.display = 'none'
          }
          this.clearTaskByCandidateId(candidateId)
        }
      }, 25)
    }
  },
  watch: {
    '$i18n.locale' () {
      if (this.editor) {
        this.editor.settings.language = isEn() ? 'en' : 'zh_CN'
        this.editor.render()
      }
    },
    value: {
      immediate: true,
      handler () {
        const value = this.value || ''
        if (this.editor) {
          const content = this.editor.getContent()
          if (content !== value) {
            this.editor.setContent(value)
            this.editor.setMode(this.disabled ? 'readonly' : 'design')
          }
        }
      }
    },
    editor (newVal, oldVal) {
      if (oldVal) {
        tinymce.remove(oldVal)
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
